'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import { linkUrl } from '@/lib/link'

import { Header } from './Header'

interface HeaderBlokProps {
  blok: {
    contactCtaText: string
    findOfficeCtaText: string
    contactCtaLink: any
    findOfficeCtaLink: any
    menuLinks: any
    mobileMenuLinks: any
    mobileMenuLinksSecondary: any
  } & SbBlokData
}

interface MenuLink {
  href: string
  text: string
  toggleDropdown?: boolean
}

interface DropdownData {
  category: string
  links: Array<{
    href: string
    text: string
    subcategory?: string
    links?: MenuLink[]
  }>
}

interface MobileMenuData {
  navigation1: MenuLink[]
  navigation2: MenuLink[]
}

const PhnxHeader: FC<HeaderBlokProps> = ({ blok }) => {
  const [menuDataBlok, setMenuData] = useState<MenuLink[]>()
  const [dropdownData, setDropdownData] = useState<DropdownData[]>([])
  const [mobileMenuData, setMobileMenuData] = useState<MobileMenuData>({
    navigation1: [],
    navigation2: [],
  })

  useEffect(() => {
    const menuDataBlok = blok.menuLinks.map((menuLink: any) => {
      return {
        href: linkUrl(menuLink.link),
        text: menuLink.title,
        toggleDropdown: menuLink?.items.length > 0,
      }
    })

    const transformedDropdownData = blok.menuLinks
      .filter((menuLink: any) => menuLink.items.length > 0)
      .map((menuLink: any) => ({
        category: menuLink.title,
        links: [
          // Make the first link the main link
          {
            href: linkUrl(menuLink.link),
            text: menuLink.title,
          },
          ...menuLink.items.map((item: any) => ({
            subcategory: item.title,
            links: item.items.map((subItem: any) => ({
              href: linkUrl(subItem.link),
              text: subItem.title,
            })),
          })),
        ],
      }))

    // set mobile menu data navigation1
    const transformMobileMenuData = blok.mobileMenuLinks.map((menuLink: any) => {
      return {
        href: linkUrl(menuLink?.link),
        text: menuLink.title,
      }
    })

    // set mobile menu data navigation2
    const mobileMenuDataSecondary = blok.mobileMenuLinksSecondary.map((menuLink: any) => {
      return {
        href: linkUrl(menuLink.link),
        text: menuLink.title,
      }
    })

    setMobileMenuData({
      navigation1: transformMobileMenuData,
      navigation2: mobileMenuDataSecondary,
    })
    setMenuData(menuDataBlok)
    setDropdownData(transformedDropdownData)
  }, [blok.menuLinks, blok.mobileMenuLinks, blok.mobileMenuLinksSecondary])

  return (
    <div {...storyblokEditable(blok)}>
      <Header
        headerNavigation={menuDataBlok}
        dropdownData={dropdownData}
        mobileMenuData={mobileMenuData}
        findOfficeCtaText={blok.findOfficeCtaText}
        findOfficeCtaLink={{
          story: {
            fullSlug: blok?.findOfficeCtaLink?.cached_url,
          },
        }}
        contactCtaText={blok.contactCtaText}
        contactCtaLink={{
          story: {
            fullSlug: blok?.contactCtaLink?.cached_url,
          },
        }}
      />
    </div>
  )
}

export default PhnxHeader
